import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Table, Badge } from 'reactstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import { fetchMatchingDashboard } from '~/services/trainingPlanAutoApply';
import { formatAutoApplyStatus } from '~/services/util';
import Loader from '~/components/Loader/Loader';

export default class TrainingPlanMatchingDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dashboard: null,
    };
  }

  componentDidMount() {
    this.loadDashboard();
  }

  loadDashboard = async () => {
    this.setState({ loading: true });
    try {
      const dashboard = await fetchMatchingDashboard();
      this.setState({ dashboard, loading: false });
    } catch (error) {
      toast.error('Erro ao carregar dashboard de matching');
      this.setState({ loading: false });
    }
  };

  formatPercent(value) {
    if (value === null || value === undefined) return '--';
    return `${Math.round(value * 100)}%`;
  }

  render() {
    const { loading, dashboard } = this.state;
    const summary = dashboard?.summary || {};

    return (
      <>
        {loading && <Loader />}

        <Row>
          <Col>
            <div className="page-title-box">
              <h4 className="page-title">Dashboard de acerto do matching</h4>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <Card>
              <CardBody>
                <h5>Total de revisões</h5>
                <h3>{summary.total_reviews ?? 0}</h3>
              </CardBody>
            </Card>
          </Col>
          <Col md={3}>
            <Card>
              <CardBody>
                <h5>Taxa de acerto</h5>
                <h3>{this.formatPercent(summary.match_accuracy_rate)}</h3>
              </CardBody>
            </Card>
          </Col>
          <Col md={3}>
            <Card>
              <CardBody>
                <h5>Matches corretos</h5>
                <h3>{summary.match_correct_count ?? 0}</h3>
              </CardBody>
            </Card>
          </Col>
          <Col md={3}>
            <Card>
              <CardBody>
                <h5>Nota média (1-5)</h5>
                <h3>{summary.average_match_quality_rating ? Number(summary.average_match_quality_rating).toFixed(1) : '--'}</h3>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Card>
              <CardBody>
                <h5>Status do auto-apply</h5>
                <Table size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(dashboard?.auto_apply_status_breakdown || []).map((row) => (
                      <tr key={row.status}>
                        <td>{formatAutoApplyStatus(row.status)}</td>
                        <td>{row.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>

          <Col md={6}>
            <Card>
              <CardBody>
                <h5>Distribuição de notas</h5>
                <Table size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th>Nota</th>
                      <th>Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(dashboard?.rating_distribution || []).map((row) => (
                      <tr key={row.rating}>
                        <td>{row.rating}</td>
                        <td>{row.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <CardBody>
                <h5>Revisões recentes</h5>
                <Table hover className="mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Solicitação</th>
                      <th>Atleta</th>
                      <th>Plano sugerido</th>
                      <th>Nota</th>
                      <th>Correto?</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(dashboard?.recent_reviews || []).map((review) => (
                      <tr key={review.id}>
                        <td>{review.id}</td>
                        <td>{review.training_plan_request_id}</td>
                        <td>
                          {review.user?.name}<br />
                          <small>{review.user?.email}</small>
                        </td>
                        <td>{review.suggested_plan_name || '--'}</td>
                        <td>{review.match_quality_rating}</td>
                        <td>
                          <Badge color={review.match_was_correct ? 'success' : 'danger'}>
                            {review.match_was_correct ? 'Sim' : 'Não'}
                          </Badge>
                        </td>
                        <td>{moment(review.created_at).format('DD/MM/YYYY HH:mm')}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}
